<div class="h-100 main-bc overflow-hidden">
    <router-outlet></router-outlet>
</div>
